import React, {useState} from 'react';
import styled from 'styled-components';
import Modal, { BaseModalBackground } from 'styled-react-modal';

const horizontalPadding = 15;

const StyledModal = Modal.styled`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 3px;
  /* viewport height minus(roughly) the fixed menus */
  max-height: 80vh;
  max-height: calc(100vh - 160px);
  max-width: ${({maxWidth}) => maxWidth || 'min(calc(100vw - 20px), 400px)'};
  min-width: ${({minWidth}) => minWidth};
  margin: 10px;
  @media (max-width: 760px) {
    margin: 5px;
  }
`;

export const ModalHeader = styled.h1`
  font-size: 24px;
  line-height: 28px;
  background-color: #ddd;
  padding: 8px ${horizontalPadding}px;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  border-radius: 3px 3px 0 0;
  display: flex;
  align-items: center;
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
`;

export const ModalBody = styled.div`
  padding: 10px ${horizontalPadding}px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 10px ${horizontalPadding}px;
  border-top: 1px #ccc solid;
  box-sizing: border-box;
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
`;

export const ModalButton = styled.button`
  background: ${({link}) => link ? 'transparent' : '#ddd'};
  color: ${({link}) => link ? '#0074cc' : '#333'};
  font-size: 1em;
  margin: 0 0 0 5px;
  padding: 0.25em 1em;
  border: 0;
  border-radius: 4px;
  border: ${({link}) => link ? 0 : '1px solid #aaa'};
  width: 100px;
  height: 38px;
  &:hover {
    background: #eee;
  }
  &:disabled {
    background: ${({link}) => link ? 'transparent' : '#ccc'};
    color: #999;
    cursor: not-allowed;
  }
  outline: 0;
`;

export const FadingBackground = styled(BaseModalBackground)`
  opacity: ${props => props.opacity};
  transition: opacity ease 300ms;
`;

const MyModal = ({show, onClose, minWidth = undefined, maxWidth = undefined, children, closeOnEscape = true, onOpen = () => {}}) => {
  const [opacity, setOpacity] = useState(0);
  const afterOpen = () => {
    setTimeout(() => {
      setOpacity(1);
    });
    onOpen();
  }
  const beforeClose = () => {
    return new Promise(resolve => {
      setOpacity(0);
      setTimeout(resolve, 200);
    });
  }
  return (
    <StyledModal
      isOpen={show}
      afterOpen={afterOpen}
      beforeClose={beforeClose}
      onEscapeKeydown={closeOnEscape && onClose}
      opacity={opacity}
      backgroundProps={{opacity}}
      maxWidth={maxWidth}
      minWidth={minWidth}
    >
      {children}
    </StyledModal>
  )
};

export default MyModal;
